<template>
  <!-- Language picker — one dropdown reused in the topbar and (float) on the auth screens.
       Reuses the theme-picker chrome (.theme-wrap/.theme-menu/.theme-scrim/.popmenu) so it
       matches the topbar theme button. mdi-translate reads clearer than the old TH/EN pill. -->
  <div class="theme-wrap lang-pick" :class="{ 'lang-pick-float': float }" v-click-outside="() => { open = false }">
    <button class="lang-btn" type="button" v-hint="title" @click="open = !open">
      <span class="mdi mdi-translate"></span>
      <span class="lang-btn-label">{{ currentNative }}</span>
      <span class="mdi mdi-chevron-down lang-caret" :class="{ up: open }"></span>
    </button>
    <template v-if="open">
      <div class="theme-scrim" @click="open = false"></div>
      <div class="popmenu theme-menu lang-menu">
        <div class="popmenu-head">
          <span class="popmenu-name"><span class="mdi mdi-web"></span> {{ title }}</span>
        </div>
        <button v-for="l in locales" :key="l.code" type="button" class="popmenu-item lang-opt"
          :class="{ on: locale === l.code }" @click="pick(l.code)">
          <span class="lang-opt-name">{{ l.native }}</span>
          <span v-if="locale === l.code" class="mdi mdi-check lang-opt-check"></span>
        </button>
      </div>
    </template>
  </div>
</template>

<script>
import { LOCALES, i18nState, setLocale } from '../../i18n';

// our short locale codes are also the Vuetify locale keys registered in main.js
const VUETIFY_LOCALE = { th: 'th', en: 'en', zh: 'zh', ja: 'ja', ko: 'ko' };
// localized word for the menu header, per active locale
const LANG_WORD = { th: 'ภาษา', en: 'Language', zh: '语言', ja: '言語', ko: '언어' };

export default {
  name: 'LangPicker',
  props: {
    // when true, pins the picker to the top-right of the viewport (auth screens)
    float: { type: Boolean, default: false },
  },
  data() {
    return { open: false, locales: LOCALES };
  },
  computed: {
    locale() {
      return i18nState.locale;
    },
    currentNative() {
      const l = LOCALES.find((x) => x.code === i18nState.locale);
      return l ? l.native : i18nState.locale;
    },
    title() {
      return LANG_WORD[i18nState.locale] || 'Language';
    },
  },
  methods: {
    pick(code) {
      setLocale(code);
      // keep Vuetify's own component strings (data-table, etc.) in sync
      if (this.$vuetify && this.$vuetify.locale) {
        this.$vuetify.locale.current = VUETIFY_LOCALE[code] || 'en';
      }
      this.open = false;
    },
  },
};
</script>

<style scoped>
.lang-pick {
  position: relative;
  display: inline-flex;
}
/* auth screens: .lg-wrap is position:fixed; z-index:1 — sit above it */
.lang-pick-float {
  position: fixed;
  top: 16px;
  right: 16px;
  z-index: 2495;
}
/* Narrow phones: match the theme button, which already drops its label at this width.
   The translate icon carries the meaning on its own and the menu still spells out every
   language, so the locale name is the cheapest thing to give up when five controls have
   to fit a ~344px bar. */
@media (max-width: 560px) {
  .lang-btn-label {
    display: none;
  }
}
.lang-caret {
  font-size: 16px !important;
  color: var(--c-text-muted) !important;
  transition: transform var(--dur-fast) var(--ease);
}
.lang-caret.up {
  transform: rotate(180deg);
}
.lang-menu {
  min-width: 184px;
}
.lang-opt-name {
  font-weight: 700;
  color: var(--c-text-heading);
  font-family: var(--font-head);
}
.lang-opt-check {
  margin-left: auto;
  color: var(--c-primary);
  font-size: 19px;
}
.popmenu-head .mdi {
  font-size: 15px;
  color: var(--c-primary);
}
</style>
